import { render } from "./Video.vue?vue&type=template&id=d0f40e04&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=d0f40e04&lang=scss&scoped=true"
import "./Video.vue?vue&type=style&index=1&id=d0f40e04&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f40e04"]])

export default __exports__